import { useState, useEffect } from "react";
import { loadMaterialCategoryList, loadMaterialCode, loadMaterialDetail } from "../services/materialCategory";

const useMaterialDetail = () => {
    const [materialDetail, setMaterialDetail] = useState([]); 
    

    // Fetch department data
    const fetchMaterialDetail = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"),p_plantid:1,p_id_material: selectedID};

        try {
            const data = await loadMaterialDetail(para);
            if (data && data.length > 0) {
                setMaterialDetail(data);         

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

  

    // Function to load department based on selected ID
    const loadMaterialDetailByID = async (selectedID) => {
        await fetchMaterialDetail(selectedID);
    };

    return {
        materialDetail,
        setMaterialDetail,        
        loadMaterialDetailByID,
    };
};

export default useMaterialDetail;
